import { render, staticRenderFns } from "./Descredenciados.vue?vue&type=template&id=7906bf13&scoped=true"
import script from "./Descredenciados.vue?vue&type=script&lang=js"
export * from "./Descredenciados.vue?vue&type=script&lang=js"
import style0 from "./Descredenciados.vue?vue&type=style&index=0&id=7906bf13&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906bf13",
  null
  
)

export default component.exports